import { render, staticRenderFns } from "./FireSimulation.vue?vue&type=template&id=2ca16f6c&scoped=true&"
import script from "./FireSimulation.vue?vue&type=script&lang=js&"
export * from "./FireSimulation.vue?vue&type=script&lang=js&"
import style0 from "./FireSimulation.vue?vue&type=style&index=0&id=2ca16f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca16f6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VIcon,VRadio,VRadioGroup,VRow})
